import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TableColumn } from './TableColumn';
import { MatSort, Sort } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable, Subscription } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AppSettings } from '../../appsettings';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class TableComponent implements OnInit, OnDestroy {

  /*Reference: https://github.com/dnlrbz/material-reusable-table*/

  tableDataSource = new MatTableDataSource([] as any);
  columnsToDisplay: string[] = [];
  @ViewChild(MatPaginator, {static: false}) matPaginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) matSort!: MatSort;

  @Input() isPageable = false;
  @Input() isSortable = false;
  @Input() isFilterable = false;
  @Input() hasCondensedHeader = false;
  @Input() hasTintedHeader = false;
  @Input() tableColumns: TableColumn[] = [];
  @Input() childTableColumns: TableColumn[] = [];
  @Input() childElementKey: string = 'concurrentAuths';
  @Input() colActionIcon!: string;
  @Input() paginationSizes: number[] = [5, 10, 15];
  @Input() defaultPageSize = this.paginationSizes[1];

  //action icon related
  @Input() showColActionIcon = false; // true, should icon column display
  @Input() showIconEdit = false;
  @Input() showIconPreview = false;
  @Input() showIconDownload = false;
  @Input() showIconDelete = false;
  @Input() showIconMenuSingleAction = false;
  @Input() showIconMenuMultiActions = false;
  @Input() hasRadio = false;

  //expandable rows related
  childColumnsToDisplay: string[] = [];
  isCollapsed: boolean = true;
  @Input() colExpandIcon!: string;
  @Input() expandedElement: TableColumn[] = [];
  @Input() hasChildDataRows = false;

  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @Output() rowAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() download: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output() preview: EventEmitter<any> = new EventEmitter<any>();

  @Input() tableDataObservable!: Observable<any>;
  timezone='';
  constructor(private appSettings: AppSettings) {
    this.timezone = this.appSettings.timeZone;
   }

  sub1!: Subscription;

  ngOnInit(): void {
    const columnNames = this.tableColumns.map((tableColumn: TableColumn) => tableColumn.name);
    if (this.hasChildDataRows && this.showColActionIcon) {
      this.columnsToDisplay = [this.colExpandIcon, ...columnNames, this.colActionIcon]
    }
    else if (this.showColActionIcon) {
      this.columnsToDisplay = [...columnNames, this.colActionIcon]
    }
    else {
      this.columnsToDisplay = columnNames;
    }

    const childColumnNames = this.childTableColumns.map((childTableColumn: TableColumn) => childTableColumn.name);
    if (this.hasChildDataRows && this.showColActionIcon) {
      this.childColumnsToDisplay = [this.colExpandIcon, ...childColumnNames, this.colActionIcon]
    }
    else if (this.showColActionIcon) {
      this.childColumnsToDisplay = [...childColumnNames, this.colActionIcon]
    }
    else {
      this.childColumnsToDisplay = childColumnNames;
    }
    this.sub1 = this.tableDataObservable.subscribe(data => {
      this.setTableDataSource(data);
    });
  }

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
  }
  
  setTableDataSource(data: any) {
    this.tableDataSource = new MatTableDataSource<any>(data);
    this.tableDataSource.paginator = this.matPaginator;
    this.tableDataSource.sort = this.matSort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();
  }

  sortTable(sortParameters: Sort) {
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns.find(column => column.name === sortParameters.active)?.dataKey as string;
    this.sort.emit(sortParameters);
  }

  emitRowAction(row: any) {
    this.rowAction.emit(row);
  }

  emitDownloadAction(row: any) {
    this.download.emit(row);
  }

  emitPreviewAction(row: any) {
    this.preview.emit(row);
  }

  emitDeleteAction(row: any) {
    this.delete.emit(row);
  }

  displayRowItem(event: Event) {
    alert('Go to Auth');
  }

}
